import React from 'react';
import styles from './exitModal.module.scss';
import Modal from '../../../components/modal/Modal';
import Button from '../../../components/button/Button';
import Spinner from '@src/components/spinner/Spinner';

type Props = {
  open: boolean;
  onNoSave: () => void;
  onSave: () => void;
  loading?: boolean;
  onClose: () => void;
};

function ExitModal(props: Props) {
  const { open, onSave, onNoSave, loading, onClose } = props;
  return (
    <Modal global={false} open={open} onClose={onClose} className={styles.wrapper} >
      <div className={styles.content}>
        <h2 className={styles.title}>Would you like to <span className='bold'>Save</span> Your <br /><span className='bold'>Progress?</span></h2>
        <div className={styles.btnWrapper}>
          <Button disabled={loading} size={'small'} onClick={onNoSave} leftIcon={loading ? <Spinner width={35} height={35} /> : undefined} className={styles.start} label={'Don’t Save'}/>
          <Button disabled={loading} size={'small'} onClick={onSave} className={styles.resume} label={'Save Progress'}/>
        </div>
      </div>
    </Modal>
  );
}

export default ExitModal;
